export default __webpack_public_path__ + "static/media/Eina01-SemiBold.32fc118c.woff2";